"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
// code taken from https://github.com/craig1123/react-recipes/blob/master/src/useDimensions.js
var react_1 = require("react");
var debounce_1 = __importDefault(require("./debounce"));
function useDimensions(liveMeasure, delay, initialDimensions, effectDeps) {
    if (liveMeasure === void 0) { liveMeasure = true; }
    if (delay === void 0) { delay = 250; }
    if (initialDimensions === void 0) { initialDimensions = {}; }
    if (effectDeps === void 0) { effectDeps = []; }
    var _a = react_1.useState(initialDimensions), dimensions = _a[0], setDimensions = _a[1];
    var _b = react_1.useState(null), node = _b[0], setNode = _b[1];
    var ref = react_1.useCallback(function (newNode) {
        setNode(newNode);
    }, []);
    react_1.useLayoutEffect(function () {
        // need ref to continue
        if (!node) {
            return;
        }
        var measure = function () {
            window.requestAnimationFrame(function () {
                var newDimensions = node.getBoundingClientRect();
                setDimensions(newDimensions);
            });
        };
        // invoke measure right away
        measure();
        if (liveMeasure) {
            var debounceMeasure_1 = debounce_1["default"](measure, delay);
            window.addEventListener('resize', debounceMeasure_1);
            window.addEventListener('scroll', debounceMeasure_1);
            return function () {
                window.removeEventListener('resize', debounceMeasure_1);
                window.removeEventListener('scroll', debounceMeasure_1);
            };
        }
    }, __spreadArrays([node, liveMeasure], effectDeps));
    return [ref, dimensions, node];
}
exports["default"] = useDimensions;
// Usage
// function App() {
//   const [wrapperRef, dimensions] = useDimensions();
//   return (
//     <div ref={wrapperRef}>
//       height: {dimensions.height}
//       width: {dimensions.width}
//     </div>
//   );
// }
